import EnvConfig from "../types/config"

const envConfig: EnvConfig = {
  boehringerProgramCode: process.env['REACT_APP_BOEHRINGER_PROGRAM_CODE'] ? parseInt(process.env['REACT_APP_BOEHRINGER_PROGRAM_CODE']) : -1,
  boehringerProgramFollowup: process.env['REACT_APP_BOEHRINGER_PROGRAM_FOLLOWUP'] || '',
  boehringerCrmIdIndustry: process.env['REACT_APP_BOEHRINGER_IDINDUSTRY'] || '',
  pharmaceuticalPortalApiUrl: process.env['REACT_APP_PORTAL_API_URL'] || '',
  originCode: process.env['REACT_APP_ORIGIN_CODE'] ? parseInt(process.env['REACT_APP_ORIGIN_CODE']) : -1,
  doctorPortal: process.env['REACT_APP_DOCTOR_PORTAL_URL'] || '',
  healthPassportPasswordResetUrl: process.env['REACT_APP_HEALTH_PASSPORT_PASSWORD_RESET_URL'] || '',
  healthPassportPasswordResetClient: process.env['REACT_APP_HEALTH_PASSPORT_PASSWORD_RESET_CLIENT'] || '',
  healthPassportPasswordResetProgram: process.env['REACT_APP_HEALTH_PASSPORT_PASSWORD_RESET_PROGRAM'] || '',
  googleSiteKey: process.env['REACT_APP_GOOGLE_SITE_KEY'] || '', 
}
  
export default envConfig
